import {StackItem} from '../../interfaces/router/stackItem';
import screens from '../../config/screens';
import SharedArticle from '../../screens/content/sharedArticle';
import {createLazyComponent} from '../../utils/lazyLoad';
import PublicChats from '../../screens/public/chats';

// Create lazy loaded component
const LazySharedArticle = createLazyComponent(SharedArticle);
const LazyPublicChats = createLazyComponent(PublicChats);

/**
 * An array of shared routes for a navigation stack.
 * @type {StackItem[]}
 */
const sharedRoutes: StackItem[] = [
  {
    name: screens.sharedArticle,
    component: LazySharedArticle,
    options: {
      headerShown: false,
    },
  },
  {
    name: screens.sharedChat,
    component: LazyPublicChats,
    options: {
      headerShown: false,
    },
  },
];

export default sharedRoutes;
